import './index.less';

import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

const UserFeedbackInner = React.lazy(() => import('./UserFeedbackInner'));

const UserFeedback = () => {
  const { t: $t, i18n } = useTranslation('user-feedback');

  return (
    <div className={classNames('userFeedBack', i18n.language)}>
      <div className="header">
        <div className="header-inner">
          <picture>
            <source
              media="(max-width:767px)"
              srcSet="/common-static/cht-static/user-svc/img/user-feedback/header_375@2x.png"
            />
            <source
              media="(max-width:1439px)"
              srcSet="/common-static/cht-static/user-svc/img/user-feedback/header_768@2x.png"
            />
            <source
              media="(max-width:1919px)"
              srcSet="/common-static/cht-static/user-svc/img/user-feedback/header_1440@2x.png"
            />
            <img
              src="/common-static/cht-static/user-svc/img/user-feedback/header_1920@2x.png"
              alt=""
            />
          </picture>
          <div className="header-title-box">
            <div className="header-title" data-paint>
              {$t('feedbackIntroHeader')}
            </div>
            <div className="header-title">{$t('feedbackIntroHeader')}</div>
            <div className="header-sub-title">
              {$t('feedbackIntroSubheader')}
            </div>
          </div>
        </div>
      </div>
      <React.Suspense fallback="">
        <UserFeedbackInner />
      </React.Suspense>
    </div>
  );
};

export default UserFeedback;
